module.exports = __webpack_public_path__ + "img/Masseur Kinésithérapeute.83e19edd.png";